import {useRouteMatch} from "react-router";

import {WideContent} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {BrandTenementIcon} from "@pg-design/icons-module";

import {ApplicationSourceSection} from "../../../../../application/utils/ApplicationSource";
import {ColumnList} from "../../../../../atoms/ColumnList";
import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {InfoPanel} from "../../../../../atoms/InfoPanel";
import {useCurrentRoute} from "../../../../../hooks/use_current_route";
import {useAppDispatch, useAppSelector} from "../../../../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../../../../store/utils/get_request_state_from_rtk_query";
import {useUserPreferencesFilters} from "../../../../../user/hooks/use_user_preferences_filters";
import {useGetOfferListQuery} from "../../../../api/get_offer_list";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {OfferModal} from "../../../../components/offer_modal/OfferModal";
import {offerModalInitialState} from "../../../../state/offer_modal_initial_state";
import {showOfferModal} from "../../../../state/offer_modals_slice";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IGetOfferListPayload} from "../../../../types/GetOfferListPayload";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";
import {IOfferModalName} from "../../../../types/OfferModalName";
import {OfferType} from "../../../../types/OfferType";
import {getSoonFinishedOffersPayload} from "../../../../utils/get_soon_finished_offers_payload";
import {getFetchOfferListQueryData} from "../../../helpers/get_fetch_offer_list_query_data";
import {getFetchOfferListSubFilterQuery} from "../../../helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {OfferListSubType} from "../../../types/OfferListSubType";

interface IProps {
    offers: IOfferListOffer[];
    dividerVisible: boolean;
}

const modalName: IOfferModalName = "mainOfferModal";

export const SoonFinishedOffersListing = (props: IProps) => {
    const dispatch = useAppDispatch();
    const modalOpened = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);

    const {
        params: {offerListSubType}
    } = useRouteMatch<{offerListSubType?: OfferListSubType}>();
    const currentRoute = useCurrentRoute();
    const userPreferencesFilters = useUserPreferencesFilters();

    const offerListQuery = getFetchOfferListSubFilterQuery(currentRoute.query, offerListSubType);
    const {safeQuery} = getFetchOfferListQueryData(offerListQuery, true);
    const fullQuery: IGetOfferListPayload = {
        ...offerListQuery,
        ...(safeQuery.type == null ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
        ...getSoonFinishedOffersPayload(1)
    };

    const {
        data: soonFinishedOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(fullQuery, {
        skip: !modalOpened
    });

    return (
        <>
            <WideContent>
                {props.dividerVisible && (
                    <InfoPanel
                        icon={BrandTenementIcon}
                        heading="Znaleźliśmy inne oferty, które mogą nie spełniać Twoich oczekiwań."
                        subHeading="Zobacz inwestycje, które wkrótce zostaną oddane do użytkowania."
                        css={[mt(4), mb(3)]}
                    />
                )}{" "}
            </WideContent>

            <ColumnList>
                {props.offers.map((offer, index) => (
                    <ColumnListItem key={offer.id}>
                        <OfferBox
                            offer={offer}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, offer, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                            index={index}
                            gtmMeta={{
                                listName: "Zobacz inwestycje, które wkrótce zostaną oddane do użytkowania",
                                listId: "inwestycje_wkrotce_oddane_do_uzywania",
                                source: "additional",
                                tileEvents: {
                                    imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                    buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                    linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                    logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                }
                            }}
                        />
                    </ColumnListItem>
                ))}
            </ColumnList>

            <OfferModal
                modalName={modalName}
                initialQueryParams={{
                    listingPage: page,
                    listingPageSize: offerModalInitialState.listingPageSize
                }}
                offersQuery={{
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isLoading: isLoading || isFetching,
                    isError,
                    requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                    data: soonFinishedOffersResponse ? soonFinishedOffersResponse.results : [],
                    count: soonFinishedOffersResponse ? soonFinishedOffersResponse.count : 0,
                    page: soonFinishedOffersResponse ? soonFinishedOffersResponse.page : 1,
                    pageSize: soonFinishedOffersResponse ? soonFinishedOffersResponse.page_size : 0
                }}
                userPreferencePropertyFilters={userPreferencesFilters}
            />
        </>
    );
};
import {useRouteMatch} from "react-router";

import {WideContent} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {BrandTenementIcon} from "@pg-design/icons-module";

import {ApplicationSourceSection} from "../../../../../application/utils/ApplicationSource";
import {ColumnList} from "../../../../../atoms/ColumnList";
import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {InfoPanel} from "../../../../../atoms/InfoPanel";
import {useCurrentRoute} from "../../../../../hooks/use_current_route";
import {useAppDispatch, useAppSelector} from "../../../../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../../../../store/utils/get_request_state_from_rtk_query";
import {useUserPreferencesFilters} from "../../../../../user/hooks/use_user_preferences_filters";
import {useGetOfferListQuery} from "../../../../api/get_offer_list";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {OfferModal} from "../../../../components/offer_modal/OfferModal";
import {offerModalInitialState} from "../../../../state/offer_modal_initial_state";
import {showOfferModal} from "../../../../state/offer_modals_slice";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IGetOfferListPayload} from "../../../../types/GetOfferListPayload";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";
import {IOfferModalName} from "../../../../types/OfferModalName";
import {OfferType} from "../../../../types/OfferType";
import {getSoonFinishedOffersPayload} from "../../../../utils/get_soon_finished_offers_payload";
import {getFetchOfferListQueryData} from "../../../helpers/get_fetch_offer_list_query_data";
import {getFetchOfferListSubFilterQuery} from "../../../helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {OfferListSubType} from "../../../types/OfferListSubType";

interface IProps {
    offers: IOfferListOffer[];
    dividerVisible: boolean;
}

const modalName: IOfferModalName = "mainOfferModal";

export const SoonFinishedOffersListing = (props: IProps) => {
    const dispatch = useAppDispatch();
    const modalOpened = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);

    const {
        params: {offerListSubType}
    } = useRouteMatch<{offerListSubType?: OfferListSubType}>();
    const currentRoute = useCurrentRoute();
    const userPreferencesFilters = useUserPreferencesFilters();

    const offerListQuery = getFetchOfferListSubFilterQuery(currentRoute.query, offerListSubType);
    const {safeQuery} = getFetchOfferListQueryData(offerListQuery, true);
    const fullQuery: IGetOfferListPayload = {
        ...offerListQuery,
        ...(safeQuery.type == null ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
        ...getSoonFinishedOffersPayload(1)
    };

    const {
        data: soonFinishedOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(fullQuery, {
        skip: !modalOpened
    });

    return (
        <>
            <WideContent>
                {props.dividerVisible && (
                    <InfoPanel
                        icon={BrandTenementIcon}
                        heading="Znaleźliśmy inne oferty, które mogą nie spełniać Twoich oczekiwań."
                        subHeading="Zobacz inwestycje, które wkrótce zostaną oddane do użytkowania."
                        css={[mt(4), mb(3)]}
                    />
                )}{" "}
            </WideContent>

            <ColumnList>
                {props.offers.map((offer, index) => (
                    <ColumnListItem key={offer.id}>
                        <OfferBox
                            offer={offer}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, offer, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                            index={index}
                            gtmMeta={{
                                listName: "Zobacz inwestycje, które wkrótce zostaną oddane do użytkowania",
                                listId: "inwestycje_wkrotce_oddane_do_uzywania",
                                source: "additional",
                                tileEvents: {
                                    imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                    buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                    linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                    logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                }
                            }}
                        />
                    </ColumnListItem>
                ))}
            </ColumnList>

            <OfferModal
                modalName={modalName}
                initialQueryParams={{
                    listingPage: page,
                    listingPageSize: offerModalInitialState.listingPageSize
                }}
                offersQuery={{
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isLoading: isLoading || isFetching,
                    isError,
                    requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                    data: soonFinishedOffersResponse ? soonFinishedOffersResponse.results : [],
                    count: soonFinishedOffersResponse ? soonFinishedOffersResponse.count : 0,
                    page: soonFinishedOffersResponse ? soonFinishedOffersResponse.page : 1,
                    pageSize: soonFinishedOffersResponse ? soonFinishedOffersResponse.page_size : 0
                }}
                userPreferencePropertyFilters={userPreferencesFilters}
            />
        </>
    );
};
